import {jobTypesJobSeekerForm} from '../constants/array-constants'

export function capitalizeFirstLetter (string) {
  return string.charAt(0).toUpperCase() + string.slice(1)
}

export const getContractTypeForEdit = (contracts) => {
  try {
    if (contracts.length > 0) {
      let result = []
      for (let i = 0; i < contracts.length; i++) {
        jobTypesJobSeekerForm.forEach(item => {
          if (item.name.includes(contracts[i])) {
            result.push(item)
          }
        })
      }
      return result
    }
    return []
  } catch (e) {
    return []
  }
}

export function calculatePercentage (total, percentage) {
  if (typeof total !== 'number' || typeof percentage !== 'number') {
    return 0
  }

  return (total * percentage) / 100
}

export function usThousandFormat (value) {
  if (typeof parseInt(value) === 'number' && !isNaN(parseInt(value))) {
    return parseInt(value).toLocaleString('en-US')
  }

  return 0
}



// WEBPACK FOOTER //
// ./src/helpers/general-helpers.js